import React from "react";
import { TableComponent2colm } from "../../Components/TableComponent";

export default function CollaborationData() {
 const userData = [
  {
    col1: "Pratham Infotech foundation",
    col2: "Soft skill training, internship & Placement assistance",
  },
  {
    col1: "DigitalEdu Pvt. Ltd.",
    col2: "Internship & Placement assistance",
  },
  {
    col1: "Vivekananda Kendra Kanyakumari",
    col2: "Training & students improvement",
  },
  {
    col1: "Tachway software solutions",
    col2: "SAP Training, Internship & placement assistance",
  },
  {
    col1: "ExcelR",
    col2: "Training & placement assistance",
  },
  {
    col1: "Institute of Cost Accountants Pimpri Chinchwad Akurdi Chapter",
    col2: "Training",
  },
  {
    col1: "Impage Tech Chinchwad",
    col2: "Training & Internship",
  },
  {
    col1: "Dhanapra Tech Wadgaonsheri, Pune",
    col2: "Training",
  },
  {
    col1: "Mitu Skillologies Pune",
    col2: "Training & placement assistance",
  },
  {
    col1: "Portalwiz Technologies Pune",
    col2: "Training & placement assistance",
  },
  {
    col1: "GTT",
    col2: "Soft skill, aptitude offline",
  },
  {
    col1: "Imarticus",
    col2: "Finance & other training online, NASSCOM",
  },
  {
    col1: "Agrezi Club Pvt. Ltd.",
    col2: "Soft skill training, workshops & seminars etc.",
  },
  {
    col1: "Anudip Foundation Pvt. Ltd.",
    col2: "Training of Java Full Stack Development, Data Analytics with Placement assistance",
  },
  {
    col1: "Anudip Foundation Pvt. Ltd.",
    col2: "Training of Certification in IT & Career readiness",
  },
  {
    col1: "Hruta Solutions Pvt. Ltd.",
    col2: "Training",
  },
  {
    col1: "Symbiosis Open Education Society",
    col2: "Training & placement assistance",
  },
];

  const tableHeaders = {
    columns: ["Sr No.", "Mou signed with ", "Objective of MOU", ""],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
      <div
        style={{
          marginTop: "32px",
          padding: "28px 32px",
          background: "#fdf2f2",
          borderLeft: "5px solid #a11d1d",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: "17px",
            lineHeight: 1.8,
            color: "#333",
            textAlign: "justify",
          }}
        >
          Our institution actively fosters{" "}
          <strong>Industry–Academia Collaboration</strong> to bridge the gap
          between academic learning and industry requirements. Through
          meaningful engagement with industry professionals and organizations,
          students gain practical exposure, contemporary knowledge, and insights
          into real-world business practices. Such collaborations strengthen
          experiential learning and enhance students' employability,
          professional skills, technological awareness, and readiness for the
          dynamic business environment, while also creating a platform for
          continuous knowledge exchange between academia and industry.
        </p>
      </div>
    </div>
  );
}
